module.exports = __webpack_public_path__ + "static/media/Button.d4076a3d.svg";